// assets/section-product-results-carousel.js

(function () {
  var tracks = document.querySelectorAll('ul[id^="Slider-"]');
  if (!tracks.length) return;

  tracks.forEach(function (track) {
    // Find the nearest Shopify section wrapper or fallback to track's parent
    var root =
      track.closest('[id^="shopify-section-"]') ||
      track.parentElement ||
      document;

    // Scope dots to this section instance only
    var dotsContainer = root.querySelector('.slider-dots');
    if (!dotsContainer) return;

    // Prevent double-binding if section re-renders
    if (dotsContainer.dataset.initialized === 'true') return;
    dotsContainer.dataset.initialized = 'true';

    var dots = dotsContainer.querySelectorAll('.slider-dot');
    if (!dots.length) return;

    dots.forEach(function (dot) {
      dot.addEventListener(
        'click',
        function (ev) {
          // Avoid page jump
          ev.preventDefault();

          // Update active state
          dots.forEach(function (d) {
            d.removeAttribute('aria-current');
          });
          this.setAttribute('aria-current', 'true');

          // Smoothly bring the target slide into view horizontally
          var hash = this.getAttribute('href');
          if (!hash || hash.charAt(0) !== '#') return;
          var targetId = hash.slice(1);
          var targetEl = root.querySelector('#' + CSS.escape(targetId));
          if (targetEl) {
            targetEl.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'start',
            });
          }
        },
        { passive: false }
      );
    });
  });
})();

(function () {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  function initAll() {
    document.querySelectorAll('.product-results').forEach(function (sectionEl) {
      var root = sectionEl.closest('[id^="shopify-section-"]') || sectionEl;

      var track = root.querySelector('ul[id^="Slider-"]');
      var prevBtn = root.querySelector('.slider-button--prev');
      var nextBtn = root.querySelector('.slider-button--next');
      if (!track) return;

      var dots = root.querySelectorAll('.slider-dots .slider-dot');
      var perPageAttr = root.querySelector('.slider-mobile-gutter')?.getAttribute('data-per-page');
      var perPage = parseInt(perPageAttr || '4', 10);
      if (!(perPage > 0)) perPage = 4;

      var pages = dots.length ? dots.length : Math.ceil(track.children.length / perPage);

      function setButtons(page) {
        if(prevBtn) prevBtn.disabled = page <= 0;
        if(nextBtn) nextBtn.disabled = page >= pages - 1;
      }

      function getCurrentPage() {
        var current = -1;
        dots.forEach(function (d, i) {
          if (d.getAttribute('aria-current') === 'true') current = i;
        });
        if (current >= 0) return current;

        var approx = Math.round(track.scrollLeft / track.clientWidth);
        if (approx < 0) approx = 0;
        if (approx > pages - 1) approx = pages - 1;
        return approx;
      }

      function goToPage(page) {
        if (page < 0) page = 0;
        if (page > pages - 1) page = pages - 1;

        if (dots.length) {
          dots.forEach(function (d) { d.removeAttribute('aria-current'); });
          if (dots[page]) dots[page].setAttribute('aria-current', 'true');
        }

        var firstIndex = page * perPage + 1;

        // SAFE: strip only the trailing "-<number>" from the first slide id
        var firstSlide = track.querySelector('li[id^="Slide-"]');
        if (!firstSlide) return;
        var idPrefix = firstSlide.id.replace(/-\d+$/, ''); // e.g. "Slide-<full section.id>"

        var targetId = idPrefix + '-' + firstIndex;
        var target = root.querySelector('#' + CSS.escape(targetId));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }

        setButtons(page);
      }

      if(prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          goToPage(getCurrentPage() - 1);
        });
      }

      if(nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          goToPage(getCurrentPage() + 1);
        });
      }

      if (dots.length) {
        dots.forEach(function (dot, i) {
          dot.addEventListener('click', function (e) {
            e.preventDefault();
            goToPage(i);
          });
        });
      }

      function updateDotsOnScroll() {
        var page = Math.round(track.scrollLeft / track.clientWidth);

        if (page < 0) page = 0;
        if (page > pages - 1) page = pages - 1;

        if (dots.length) {
          dots.forEach(function (d) {
            d.removeAttribute('aria-current');
          });
          if (dots[page]) {
            dots[page].setAttribute('aria-current', 'true');
          }
        }

        setButtons(page);
      }

      // Throttle scroll updates (prevents performance issues)
      var ticking = false;

      track.addEventListener('slide-stop', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () {
            updateDotsOnScroll();
            ticking = false;
          });
          ticking = true;
        }
      });

      setButtons(getCurrentPage());
    });
  }
})();
